const PlayCircle = (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M40.0003 73.3334C58.4098 73.3334 73.3337 58.4096 73.3337 40.0001C73.3337 21.5906 58.4098 6.66675 40.0003 6.66675C21.5908 6.66675 6.66699 21.5906 6.66699 40.0001C6.66699 58.4096 21.5908 73.3334 40.0003 73.3334Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M33.333 26.6667L53.333 40.0001L33.333 53.3334V26.6667Z"
      fill="white"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default PlayCircle;
